<template>
	<a-drawer title="优质内容奖励申报" width="80%" :closable="false" :visible="visible" :destroyOnClose="true" @close="onClose">
		<div style="padding-bottom: 10px;">
			<div style="float: right;">
				<Approval @success="success" v-if="!notApprovalStateArr.includes(award.applyStatus)" :type="'award'" :uuid="award.uuid"/>
			</div>
		</div>
		<div style="margin:30px auto">
		    <div>
				<a-steps>
				    <a-step :status="item.status" :title="item.title" :description="item.description" v-for="(item,index) in award.stepList" :key="index">
				        <a-icon :type="item.type" slot="icon" style="font-size:24px;"/>
				    </a-step>
				</a-steps>
			</div>
			<div style="margin-top: 20px;">
				<UserTaskRecord :businessType="'award'" :uuid="award.uuid"></UserTaskRecord>
			</div>
		</div>
		<a-divider>申请信息</a-divider>
		<a-table :bordered="true" :columns="innerColumns" :data-source="dataSource" :pagination="false" :scroll="{ x: 4000, y: 3000 }">
			<template slot="action" slot-scope="text, record">
				 <a size="small" @click="checkFile(record)">查看附件</a>
			</template>
		</a-table>
		<FileList :visible="fileListDialog" @close="fileListDialog = false" @success="(fileListDialog = false), search()" ref="fileListDialog"></FileList>
	</a-drawer>
</template>

<script>
	import Content from './weiboContent';
	import UserTaskRecord from './userTaskRecord';
	import Approval from './approval';
	import FileList from './fileList';

	const formItemLayout = {
		labelCol: {
			span: 2
		},
		wrapperCol: {
			span: 22
		}
	}

	const innerColumns = [
	  { title: '申请子编号', dataIndex: 'sn',align: 'center',fixed: 'left',width: 120},
	  { title: '平台', dataIndex: 'platform_type_text',align: 'center',fixed: 'left',width: 100},
	  { title: '账号名称', dataIndex: 'account_name',align: 'center',fixed: 'left',width: 150},
	  { title: '账号ID', dataIndex: 'account_number',align: 'center',fixed: 'left',width: 150},
	  { title: '账号性质', dataIndex: 'account_nature_text',align: 'center',width: 100},
	  { title: '奖励平台类型', dataIndex: 'award_platform_type_text',align: 'center',width: 100},
	  { title: '是否重点领域账号', dataIndex: 'whether_key_area_account_text',align: 'center',width: 100},
	  { title: '本月更频达15条', dataIndex: 'whether_reach_number_text',align: 'center',width: 100},
	  { title: '奖励类型', dataIndex: 'award_type_text',align: 'center',width: 100},
	  { title: '内容类型', dataIndex: 'content_type_text',align: 'center',width: 100},
	  { title: '奖励级别', dataIndex: 'data_demand_text',align: 'center',width: 100},
	  { title: '粉丝层级', dataIndex: 'fans_level_text',align: 'center',width: 100},
	  { title: '热搜话题', dataIndex: 'hot_topic',align: 'center',width: 100, ellipsis: true},
	  { title: '优质内容链接', dataIndex: 'content_url',align: 'center', width: 200, ellipsis: true},
	  { title: '真实数据', dataIndex: 'real_num',align: 'center',width: 100},
	  { title: '申报金额', dataIndex: 'amount',align: 'center',width: 100,scopedSlots: { customRender: 'formatMoney' },},
	  {title:'参与人', dataIndex: 'participant', align:'center' ,children: []},
	  {title:'备注', dataIndex: 'remark', align:'center', width: 200},
	  {title: '附件',dataIndex: 'action',scopedSlots: { customRender: 'action' },align: 'center',fixed: 'right',width: 100}
	];

	export default {
		props: {
			visible: {
				default: false
			},
		},
		components:{
			Content,
			UserTaskRecord,
			Approval,
			FileList
		},
		data() {
			return {
				platformDataList: [
					{name: '微博',value: 'weibo',color: '#FED754',url: '../../../../static/img/weibo.png'},
					{name: '抖音',value: 'douyin',color: '',url: '../../../../static/img/douying.png'},
					{name: 'B站',value: 'bilibili',color: '',url: '../../../../static/img/blibli.png'},
					{name: '小红书',value: 'redbook',color: '', url: '../../../../static/img/redbook.png'},
					{name: '快手',value: 'kuaishou',color: '', url: '../../../../static/img/kuaishou.png'},
					{name: '视频号',value: 'channels',color: '', url: '../../../../static/img/channels.png'},
				],
				platformTypeArr: [],
				formItemLayout,
				form: this.$form.createForm(this),
				id: null,
				loading: false,
				moveIndex: null,
				accountList: [],
				award: {},
				notApprovalStateArr: ['team_leader_resubmit','audit_resubmit'],
				innerColumns,
				dataSource: [],
				fileListDialog: false
			}
		},
		methods: {
			init({...item}){
				this.id = item.id;
				this.$get("awardApply/get", {id: item.id}).then(res => {
					this.award = res.data.data;
				})
				this.$get("dictionary-detail/listByDictType/award_post").then(res => {
					let elementList = res.data;
					let elementArr = [];
					elementList.forEach(e => {
						elementArr.push({
							title: e.value,
							dataIndex: e.key+'info',
							children: [
								{
									title: '姓名',
									dataIndex: e.key+'User',
									align:'center',
									width: 80
								},
								{
									title: '奖励比例',
									dataIndex: e.key+'Percent',
									align:'center',
									width: 80
								},
								{
									title: '奖励金额',
									dataIndex: e.key+'Amount',
									align:'center',
									width: 80
								},
							],
							align:'center',
							width: 200
						})
					})
					this.$lodash.find(this.innerColumns, {dataIndex: 'participant'}).children = elementArr;
				}).then(() => {
					this.$get("awardApplyItem/list", {applyId: item.id}).then(res => {
						this.dataSource = res.data.data;
					})
				})
			},
			success(){
				this.$emit('success');
			},
			onClose() {
				this.form.resetFields();
				this.$emit('close')
			},
			checkFile(row){
				this.fileListDialog = true;
				this.$refs.fileListDialog.init(row);
			}
		},
	}
</script>
<style lang="less" scoped>
	.heder{
	  background-color: #fff;
	  display: flex;
	  flex-wrap: wrap;
	  align-items: center;
	  .selectPlatform{
	    margin: 0 10px 0 6%;
	    color: #9094a3;
	  }
	  .platform{
	    width: 15%;
	    height: 50px;
	    font-size: 16px;
	    display: flex;
	    align-items: center;
	    justify-content: center;
	    border: 1px solid #e7e7e7;
	    border-radius: 6px;
		margin-bottom: 10px;
	    margin-right: 10px;
	    cursor: pointer;
	    img{
	      width: 30px;
	      margin-right: 10px;
	    }
	  }
	  .active{
	    border: 1px solid #74D56F !important;
	    background-color: #40AE36;
	    color: #fff;
	  }
	  .forbid{
	    background-color: #F5F5F5;
	    cursor: not-allowed !important;
	  }
	}
	.formItemLayoutBackground{
		/deep/.ant-collapse-borderless > .ant-collapse-item > .ant-collapse-content{
			background-color: #fff !important;
			border: 1px solid #E8E8E8 !important;
		}
		/deep/ table {
			border-left: 1px solid black !important;
			border-bottom: 1px solid black !important;
		}
		/deep/ table > .ant-table-thead > tr > th {
			border-right: 1px solid black !important;
			border-top: 1px solid black !important;
		}
		/deep/ table > .ant-table-tbody > tr > td {
			border-right: 1px solid black !important;
			border-top: 1px solid black !important;
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/OA/qualityContent/qualityContentView.vue